import { render, staticRenderFns } from "./WarningAlert.vue?vue&type=template&id=da70c0f4&"
import script from "./WarningAlert.vue?vue&type=script&lang=js&"
export * from "./WarningAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports